/**
 * Informe de inspección previa en ventana independiente (Diego 2026-09-17):
 * la misma pantalla del tracking de Inspección Previa (Infoinsp) con su
 * propia ruta, para abrirla aparte desde la banda del DO igual que el visor
 * de Genio. La sesión viene persistida, así que la ventana nueva ya está
 * autenticada; sin sesión vuelve al inicio.
 * @author Diego Serrano <diego.serrano@repremundo.com.co>
 * @since 2026-09-17
 */
import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useParams } from "react-router-dom";
import Infoinsp from "../components/Modimpxx/Trackins/Infoinsp";
import { getisLoggedIn } from "../libs/redux/slices/authSlice/authSlice";

const InformeInspeccionPage = () => {
  const { DOCNROXX } = useParams();
  const isLoggedIn = useSelector(getisLoggedIn);
  if (!isLoggedIn) {
    return <Navigate to="/" />;
  }
  //Infoinsp ya trae su propio lienzo RIO 360 (riodo-escala > riodo)
  return (
    <div style={{ minHeight: "100vh", background: "#F5F5F5" }}>
      <Infoinsp DOCNROXX={DOCNROXX} onVolver={() => window.close()} />
    </div>
  );
};

export default InformeInspeccionPage;
